var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58331 3.5415C4.58331 3.5415 4.58331 4.02067 4.58331 4.1665C4.58331 4.85817 4.02498 5.4165 3.33331 5.4165C3.18748 5.4165 2.70831 5.4165 2.70831 5.4165V4.37484C2.70831 3.9165 3.08331 3.5415 3.54165 3.5415H4.58331Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58331 11.6665C4.58331 11.8123 4.58331 12.2915 4.58331 12.2915H3.54165C3.08331 12.2915 2.70831 11.9165 2.70831 11.4582V10.4165C2.70831 10.4165 3.18748 10.4165 3.33331 10.4165C4.02498 10.4165 4.58331 10.9748 4.58331 11.6665Z",
    fill: "#131313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2917 4.37484V5.4165C17.2917 5.4165 16.8125 5.4165 16.6667 5.4165C15.975 5.4165 15.4167 4.85817 15.4167 4.1665C15.4167 4.02067 15.4167 3.5415 15.4167 3.5415H16.4584C16.9167 3.5415 17.2917 3.9165 17.2917 4.37484Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2917 10.4165V11.4582C17.2917 11.9165 16.9167 12.2915 16.4584 12.2915H15.4167C15.4167 12.2915 15.4167 11.8123 15.4167 11.6665C15.4167 10.9748 15.975 10.4165 16.6667 10.4165C16.8125 10.4165 17.2917 10.4165 17.2917 10.4165Z",
    fill: "#131313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75016C15.4603 8.75016 15.8334 8.37707 15.8334 7.91683C15.8334 7.45659 15.4603 7.0835 15 7.0835C14.5398 7.0835 14.1667 7.45659 14.1667 7.91683C14.1667 8.37707 14.5398 8.75016 15 8.75016Z",
    fill: "#131313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00002 8.75016C5.46026 8.75016 5.83335 8.37707 5.83335 7.91683C5.83335 7.45659 5.46026 7.0835 5.00002 7.0835C4.53978 7.0835 4.16669 7.45659 4.16669 7.91683C4.16669 8.37707 4.53978 8.75016 5.00002 8.75016Z",
    fill: "#131313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4583 12.2915H3.54165C3.08123 12.2915 2.70831 11.9186 2.70831 11.4582V4.37484C2.70831 3.91442 3.08123 3.5415 3.54165 3.5415H16.4583C16.9187 3.5415 17.2916 3.91442 17.2916 4.37484V11.4582C17.2916 11.9186 16.9187 12.2915 16.4583 12.2915Z",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.2083C11.0355 10.2083 11.875 9.18232 11.875 7.91667C11.875 6.65101 11.0355 5.625 10 5.625C8.96447 5.625 8.125 6.65101 8.125 7.91667C8.125 9.18232 8.96447 10.2083 10 10.2083Z",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70831 14.375H17.2916",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70831 16.4585H17.2916",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIcon);
export default __webpack_public_path__ + "static/media/loan-icon.05e0c047eb788266f6e20ac4cb81d68e.svg";
export { ForwardRef as ReactComponent };